import React, { useRef } from 'react'
import ReactModal from 'react-modal'
import ModalClose from './modalClose'
import dayjs from 'dayjs'
import { FULL_DAYS } from '../constants/Dates'
import Button from '../views/Button'
import { Query } from 'react-apollo'
import { ErrorTemplate, LoadingTemplate } from '../Middleware/ResponseMiddleware'

import '../styles/press-modal.scss'

const PressModal = ({ showModal, request, handleCloseModal, data, heading }) => {
  const dataRef = useRef(null)

  const copyToClipboard = async () => {
    try {
      // Copy as HTML with semantic tags
      const htmlContent = dataRef.current.innerHTML

      // Create a ClipboardItem with both HTML and plain text
      // eslint-disable-next-line no-undef
      const clipboardItem = new ClipboardItem({
        'text/html': new Blob([htmlContent], { type: 'text/html' }),
        'text/plain': new Blob([dataRef.current.innerText], { type: 'text/plain' }),
      })

      await navigator.clipboard.write([clipboardItem])
    } catch (err) {
      console.error('Failed to copy: ', err)
      // Fallback for older browsers
      try {
        const textContent = dataRef.current.innerText
        await navigator.clipboard.writeText(textContent)
      } catch (fallbackErr) {
        console.error('Fallback copy also failed: ', fallbackErr)
      }
    }
  }

  return (
    <>
      <ReactModal
        isOpen={showModal}
        contentLabel="onRequestClose Example"
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
        style={{
          overlay: {
            position: 'fixed',
            zIndex: 40,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
          content: {
            position: 'absolute',
            top: '40px',
            left: '50%',
            right: 'auto',
            transform: 'translateX(-50%)',
            bottom: '40px',
            minWidth: '290px',
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '40px 30px 20px 30px',
          },
        }}
      >
        <ModalClose onClick={handleCloseModal} />
        <Button onClick={copyToClipboard}>Kopier alle</Button>
        <div ref={dataRef} className="press-modal">
          {data ? (
            data.map((item, index) => {
              const [name] = item[0].eventName.split(':')
              const currentDate = dayjs(item[0].date)
              const dayName = FULL_DAYS[currentDate.get('d')] + ' ' + currentDate.format('DD.MM')
              const capitalizedName = dayName[0].toUpperCase() + dayName.slice(1)
              const className = item[0].className
              return (
                <div key={index} className="table">
                  <h1>
                    {capitalizedName} - {name}
                  </h1>
                  <h4>{className}</h4>
                  <div className="list">
                    {item.map((subItem, index) => (
                      <div key={index}>
                        <p>
                          {index + 1}, {subItem.name}, {subItem.clubName}{' '}
                          {subItem.series[subItem.series.length - 1].sum}
                        </p>
                      </div>
                    ))}
                  </div>
                  <hr></hr>
                </div>
              )
            })
          ) : (
            <div className="table">
              <Query query={request.query} variables={request.variables} fetchPolicy="cache-and-network">
                {({ loading, error, data }) => {
                  if (loading) {
                    return <LoadingTemplate />
                  }

                  if (error) {
                    return ErrorTemplate(error)
                  }

                  const shooters = data.getReport.ranks

                  if (!shooters.length) {
                    return null
                  }

                  const isFE = data.getReport.organizationGroup1Id === 'FE'

                  return (
                    <>
                      <h1>{heading.title}</h1>
                      <h4>{heading.description}</h4>
                      <div className="list">
                        {shooters.map((item, index) => (
                          <div key={index}>
                            <p>
                              {item.rank}, {item.name}, {item.shooters[0].clubName}{' '}
                              {isFE ? `${item.sum}/${item.sumInner}` : item.sum}
                            </p>
                          </div>
                        ))}
                      </div>
                      <hr></hr>
                    </>
                  )
                }}
              </Query>
            </div>
          )}
        </div>
      </ReactModal>
    </>
  )
}

export default PressModal
